const assesorList = [
  { name: 'Landmark Taxroll', value: 'Assessor Tax File Import' },
  { name: 'Landmark Mobile Homes', value: 'Assessor MH File Import' },
  { name: 'Tulsa Taxroll', value: 'Assessor Tulsa Tax File Import' },
  { name: 'Tulsa Special Assessment', value: 'Assessor Tulsa Special Assessment File Import' },
  { name: 'Special Assessment CSV - Headerless', value: 'Assessor Special Assessment CSV (Headerless)' },
  { name: 'Special Assessment CSV - Header', value: 'Assessor Special Assessment CSV (Header)' },
  { name: 'Fire Tax', value: 'Assessor Fire Tax File Import' },
  { name: 'Fire Tax (Wagoner County)', value: 'Assessor Fire Tax File Import(Wagoner County)' },
  { name: 'Extra Fire Tax (Wagoner County)', value: 'Assessor Extra Fire Tax File Import(Wagoner County)' },
];

const assesorListTwo = [
  { name: 'Accessor Tax', value: 'Assessor Tax File Import' },
  { name: 'Accessor MH', value: 'Accessor MH' },
];

export { assesorList, assesorListTwo };
